import { connect } from 'react-redux';
import { getFeeTypesBegin, getInvoiceTypesBegin } from '../../../../store/actions/accounting.actions';
import { updateCitationBegin } from '../../../../store/actions/citation.actions';
import { getPersonContactsBegin, getPersonDetailBegin } from '../../../../store/actions/person.actions';
import {
    getFeeTypes,
    getInvoiceTypes,
    getInvoiceTypesLoading,
    getFeeTypesLoading,
} from '../../../../store/selectors/accounting.selectors';
import {
    getPersonContactLoader,
    getPersonContacts,
    getPersonDetail,
    getPersonDetailLoading,
} from '../../../../store/selectors/person.selectors';

import Fees from './Fees';

const mapStateToProps = (state: any) => ({
    invoiceTypes: getInvoiceTypes(state),
    invoiceTypesLoading: getInvoiceTypesLoading(state),
    feeTypes: getFeeTypes(state),
    feeTypesLoading: getFeeTypesLoading(state),
    contacts: getPersonContacts(state),
    contactsLoading: getPersonContactLoader(state),
    person: getPersonDetail(state),
    personLoading: getPersonDetailLoading(state),
});

const mapDispatchToProps = {
    getInvoiceTypes: getInvoiceTypesBegin,
    getFeeTypes: getFeeTypesBegin,
    getContacts: getPersonContactsBegin,
    getPersonDetail: getPersonDetailBegin,
    updateCitation: updateCitationBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(Fees);
